module.exports = {
  headline: 'Get Started',
  title: 'New Customer at Spotin',
  text: 'Please fill in the form so that the Spotin team can get you up and running',
  titleText: 'Please fill in the required details below to enable Spotin to integrate your organization. If there are any questions contact',
  businessHeader: 'Business Details',
  companyNameLabel: 'Company Name',
  businessContactHeader: 'Business Contact',
  businessText: 'Details to your primary business development contact for Spotin. E.g. for potential collaborations with partnering content makers.',
  accountingHeader: 'Bank Account & Accounting',
  accountingText: 'Spotin’s agreement with the payment provider is used for customers’ payments. Once paid Spotin mediates the payment to the bank account provided below.',
  bankAccountText: 'Your company bank account to which Spotin shall send payments from customers to',
  bankAccountLabel: 'Bank account',
  accountingEmailText: 'Email to which accounting details shall be sent to.',
  technicalHeader: 'Technical Details',
  technicalContactHeader: 'Technical Contact',
  technicalContactText: 'Technical contact for initial integration meeting and in the event of clarifications surrounding custom details on your system and/or data.',
  platformHeader: 'E-commerce Platform',
  platformText: 'Tell us about the platform you are using so we can get started on integration you with Spotin.',
  otherDetailsText: 'Other details which may be relevant for the integration (for example business system used). These details will be discussed during the integration meeting by Spotin:s integration team. The integration meeting is held before the integration work is started by Spotin:s integration team.',
  selectDefault: 'Select',
  otherPlatformLabel: '(If other)',
  platformVersionLabel: 'Platform version',
  additionalDetailsLabel: 'Additional details (Optional)',
  mailOrderHeader: 'Order via Mail (Optional)',
  mailOrderText: 'Spotin has an additional ordersystem via mail that allows you to receieve orders via mail. The orders are in this system manually added to your system. This system can be used:',
  mailOrderUseCase1: 'In case complete order integration support is not already available for your e-commerce platform or the business system the integration is made towards. (In such case the mail order system makes can be used until a complete order integration support has been added to start selling via Spotin.)',
  mailOrderUseCase2: 'As backup in case the primary order system goes down',
  mailOrderConfirmationText: 'Confirm if you want to use the mail order system as described above:',
  mailOrderConfirm: 'Yes (Recommended)',
  mailOrderDecline: 'No',
  mailOrderEmailText: 'Email to which orders shall be sent to? (If yes above.)',
  logoText: 'The logo file shall fulfill the following criteria:',
  logoRequirement1: 'The logo shall be in vector file format. SVG (recommended), EPS or AI or comparable file format, max 5 MB',
  logoRequirement2: 'The background of the logo shall be transparent',
  logoRequirement3: '(Optional) If you have black and white versions of the logo, or smaller versions of the logo we recommend you to include these versions',
  logoRequirement4: 'Alternatively you can email the logos to',
  mailto: 'info@spotin.com',
  buttonText: 'Send',
  altText: 'Or send us an email:',
  sentHtml: `Email sent<br><br>We will get back to you shortly.<br><br><br>Kind regards<br><br>Spotin<br><br><br>`,
  errorFileTooLargeHtml: `Failed to send email<br><br>One or more logo files are larger than 5 MB.<br>Please contact us if you cannot reduce the file size.<br><br><br>Kind regards<br><br>Spotin<br><br><br>`,
  errorGenericHtml: `Failed to send email<br><br>Something went wrong while sending the form<br>Please contact us about this.<br><br><br>Kind regards<br><br>Spotin<br><br><br>`,
  nameLabel: 'Name',
  emailLabel: 'Email',
  phoneLabel: 'Phone (Optional)',
  subjectLabel: 'Subject',
  messageLabel: 'Message',
};



// WEBPACK FOOTER //
// ./pages/content/integration_EN.js